import React, { forwardRef } from "react";
import { Button, Badge } from "@mui/material";
import FilterAltOutlined from "@mui/icons-material/FilterAltOutlined";

type FilterButtonProps = {
  onClick: () => void;
  filterCount?: number;
};

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ onClick, filterCount = 0 }, ref) => {
    return (
      <Button
        ref={ref}
        variant="text"
        color="primary"
        startIcon={
          <Badge
            badgeContent={filterCount}
            color="primary"
            sx={{
              mr: filterCount > 0 ? 0.5 : -0.5,
              transition: "margin 0.3s ease-in-out",
            }}
          >
            <FilterAltOutlined />
          </Badge>
        }
        onClick={onClick}
      >
        Filters
      </Button>
    );
  }
);

FilterButton.displayName = "FilterButton";

export default FilterButton;
